exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cof-field[data-v-4e2c3c8d] {\n  margin-right: 5px;\n}\n.errors[data-v-4e2c3c8d] {\n  color: #ff0000 !important;\n}\n.key-wrap[data-v-4e2c3c8d] {\n  max-width: 100px;\n  word-wrap: break-word;\n}\n.fee-checkbox[data-v-4e2c3c8d] {\n  -webkit-appearance: checkbox;\n}", ""]);

// exports
